export default "__VITE_ASSET__IXnm$W2X__"